import React from "react";
import { useMaps } from "../_contexts";
import { useEventListener } from "../_hooks";

export function InteractiveModeOverlay() {
  const { toggleInteractiveMode } = useMaps();

  const handleCancel = () => {
    toggleInteractiveMode(false);
  };

  const handleKey = (e) => {
    switch (e.key.toLowerCase()) {
      case "escape": {
        e.preventDefault();
        e.stopPropagation();
        handleCancel();
      }
    }
  };

  useEventListener("keyup", handleKey);

  return (
    <div
      className="chronos-interactive-mode-history-overlay chronos-overlay"
      onClick={handleCancel}
    >
      <div className="chronos-interactive-mode-help-text">
        <h4 className="chronos-interactive-help-title">Marker Mode</h4>
        <p>Drag to pan the map, then click to place a marker</p>
        <p className="chronos-interactive-help-subtext">
          You can press <kbd>ESC</kbd> or click here to cancel
        </p>
      </div>
    </div>
  );
}
